// Function for page load items
export function InsightsOnLoad(){
(function($) {
    function getURLParams(url) {
        return Object.fromEntries(new URL(url).searchParams.entries());
    }
    var params = getURLParams(window.location.href);
    let window_size = $(window).width();
    let tipologia_id = params['typo'];
    let country_id = params['country'];
    let geo_id = params['geo'];
    if(tipologia_id != '' || tipologia_id != undefined){
        $('#tipologia_posts_select').val(tipologia_id);
    }
    if(country_id != '' || country_id != undefined){
        $('#country_posts_select').val(country_id);
    }
    if(geo_id != '' || geo_id != undefined){
        $('#geo_area_posts_select').val(geo_id);
    }
    // Esegui la richiesta AJAX
    $.ajax({
        url: ajax_carousel_posts.ajax_url,
        type: 'post',
        data: {
            action: 'insights_posts_onload',
            windowSize: window_size,
            tipologiaID: tipologia_id,
            countryID: country_id,
            geoID: geo_id,
        },
        success: function(response) {
             // Accedi ai valori dalla risposta
             let htmlContent = response.html;
             let hasMorePosts = response.has_more_posts;

             // Utilizza i valori come necessario
             $('#ajax_content_insights').html(htmlContent);
             if(!hasMorePosts){
                 $("#more_insights").hide();
             }
        },
        error: function(error) {
            console.log(error);
        }
    });
    $('.insights_posts_container #reset_action').click(function(){
        InsightsOnLoad();
        $('#geo_area_posts_select').val(null).trigger('change');
        $('#years_select').val(null).trigger('change');
        $('#tipologia_posts_select').val(null).trigger('change');
        $('#country_posts_select').val(null).trigger('change');
        $('#competence_area_posts_select').val(null).trigger('change');
        $('#custom_search_input_text').val(null).trigger('change');
        $('.tag_item').removeClass('active');
    })
})(jQuery);
}

let pageNumber = 1;
//Function for filtering
export function insightsListFiltering(){
(function($) {
    function load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id){
        let window_size = $(window).width();
        pageNumber = 1;
        $("#more_insights").show();
        $.ajax({
            url: ajax_carousel_posts.ajax_url, // La variabile ajax_url è fornita da WordPress
            type: 'post',
            data: {
                action: 'insights_filters',
                windowSize: window_size,
                competenceID: competence_id,
                tipologiaID: tipologia_id,
                geoID: geo_id,
                countryID: country_id,
                year: year,
                textInput: text_input,
                tagID: tag_id,
            },
            success: function(response) {
                // Accedi ai valori dalla risposta
                let htmlContent = response.html;
                let hasMorePosts = response.has_more_posts;

               // Utilizza i valori come necessario
                $('#ajax_content_insights').html(htmlContent);
                if(!hasMorePosts){
                    $("#more_insights").hide();
                }
            },
            error: function(error) {
                console.log(error);
            }
        });
        return false;
    }

    //load_people();

    $('#geo_area_posts_select').on('change', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $('#country_posts_select').on('change', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $("#years_select").on('change', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $("#tipologia_posts_select").on('change', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $("#competence_area_posts_select").on('change', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $("#custom_search_input_text").on('input', function(){
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    $(".tag_item").on('click', function(){
        $(".tag_item").removeClass('active');
        $(this).addClass('active');
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $(this).data('tag');
        load_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    })

    // $('#reset_action').on('click', function(){
    //     load_insights(null, null, null);
    //     $('#people_role_select').val(null).trigger('change');
    //     $('#people_country_select').val(null).trigger('change');
    //     $('#people_competence_area_select').val(null).trigger('change');
    // })

})(jQuery);
}

//Function for load more of listing items
export function AjaxLoadInsights(){
(function($) {
    let window_size = $(window).width();
    let ppp = 9;// Post per page
    //let pageNumber = 1;
    
    function load_posts_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id){
        pageNumber++;
        $('p#loading_text').show();
        $("#more_insights").hide();
        $.ajax({
            type: "POST",
            dataType: "html",
            url: ajax_posts.ajaxurl,
            data: {
                action: 'more_insights_ajax',
                competenceID: competence_id,
                tipologiaID: tipologia_id,
                geoID: geo_id,
                countryID: country_id,
                year: year,
                textInput: text_input,
                tagID: tag_id,
                windowSize: window_size,
                pageNumber: pageNumber,
                ppp: ppp
            },
            success: function(data){
                let response = JSON.parse(data);
                let html = response.html;
                let has_more_posts = response.has_more_posts;
                let $data = $(html);
                if($data.length){
                    $("#ajax_content_insights").append($data);
                    $('p#loading_text').hide();
                    $("#more_insights").show();
                    $("#more_insights").attr("disabled",false); // Uncomment this if you want to disable the button once all posts are loaded
                    if (has_more_posts) {
                        $("#more_insights").attr("disabled", false);
                    } else {
                        $("#more_insights").hide();
                    }
                }else{
                    $("#more_insights").hide(); // This will hide the button once all posts have been loaded
                    $('p#loading_text').hide();
                }
            },
            error : function(jqXHR, textStatus, errorThrown) {
                //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            }
    
        });
        return false;
    }
    
    $("#more_insights").on("click",function(e){ // When btn is pressed.
        e.preventDefault();
        let geo_id = $('#geo_area_posts_select').val();
        let country_id = $('#country_posts_select').val();
        let year = $('#years_select').val();
        let tipologia_id = $('#tipologia_posts_select').val();
        let competence_id = $('#competence_area_posts_select').val();
        let text_input = $('#custom_search_input_text').val();
        let tag_id = $('.tag_item.active').data('tag');
        load_posts_insights(competence_id, tipologia_id, geo_id, country_id, year, text_input, tag_id);
    });
})(jQuery);
}
